import Highlight, { defaultProps } from "prism-react-renderer";
import { useMaterialUIController } from "context";
import theme from "prism-react-renderer/themes/vsDark";
import themeDark from "prism-react-renderer/themes/dracula";
import { Wrapper, Pre, Line, LineNo, LineContent } from "./styles";
import PropTypes from "prop-types";

function HighlightedCode(props) {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <Wrapper>
      {props?.enableNumbering ? (
        <Highlight
          {...defaultProps}
          theme={theme}
          code={props.code}
          language="javascript"
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <Pre className={className} style={style}>
              {tokens.map((line, i) => {
                const { key: lineKey, ...lineProps } = getLineProps({ line, key: i });
                return (
                  <Line key={i} {...lineProps}>
                    <LineNo>{i + 1}</LineNo>
                    <LineContent>
                      {line.map((token, key) => {
                        const { key: tokenKey, ...tokenProps } = getTokenProps({ token, key });
                        return <span key={key} {...tokenProps} />;
                      })}
                    </LineContent>
                  </Line>
                );
              })}
            </Pre>
          )}
        </Highlight>
      ) : (
        <Highlight
          {...defaultProps}
          theme={darkMode ? themeDark : theme}
          code={props.code}
          language="jsx"
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <Pre className={className} style={style}>
              {tokens.map((line, i) => {
                const { key: lineKey, ...lineProps } = getLineProps({ line, key: i });
                return (
                  <div key={i} {...lineProps}>
                    {line.map((token, key) => {
                      const { key: tokenKey, ...tokenProps } = getTokenProps({ token, key });
                      return <span key={key} {...tokenProps} />;
                    })}
                  </div>
                );
              })}
            </Pre>
          )}
        </Highlight>
      )}
    </Wrapper>
  );
}

HighlightedCode.propTypes = {
  enableNumbering: PropTypes.bool,
  code: PropTypes.string.isRequired,
};
export default HighlightedCode;
